import React from 'react'
import {
  Banner,
  BannerTextContainer,
  BannerText,
  BannerTitle,
  BannerDescription,
  BannerLinks,
  Button,
  BannerImageContainer,
  BannerImage,
  ProgressiveImage,
  FluidImage,
} from '@vp/swan'
import { TAKE_YOUR_BUSINESS_FURTHER__DATA_SECTION_LABEL, GET_STARTED_CTA_DETAIL, useTrackOnComponentView } from '../WixWebsitesAnalytics'
import { McsFeatureGroupModel } from '../types/McsTypes'

export interface BannerModel {
  feature: McsFeatureGroupModel
  ctaClick: Function
  isEnabled: boolean
  trackingSpecsKey: string | null
}

interface PartnerCarouselSlideProps {
  banner: BannerModel
}

const PartnerCarouselSlide: React.FC<PartnerCarouselSlideProps> = ({ banner }) => (
  <Banner ref={useTrackOnComponentView(banner.trackingSpecsKey)} variant="card" backgroundColor="standard" textBoxHorizontalAlign="right">
    <BannerTextContainer>
      <BannerText>
        <BannerTitle as="h2">{banner.feature.title}</BannerTitle>
        <BannerDescription>{banner.feature.description}</BannerDescription>
        <BannerLinks>
          <Button
            skin="primary"
            data-position="10"
            data-section={TAKE_YOUR_BUSINESS_FURTHER__DATA_SECTION_LABEL}
            data-translation={GET_STARTED_CTA_DETAIL}
            onClick={() => banner.ctaClick()}
          >
            {banner.feature?.features?.[0]?.name}
          </Button>
        </BannerLinks>
      </BannerText>
    </BannerTextContainer>
    <BannerImageContainer>
      <BannerImage>
        <ProgressiveImage
          placeholder={banner.feature.mediaLink?.[0]?.secure_url}
          srcSet={banner.feature.mediaLink?.[0]?.secure_url}
          src={banner.feature.mediaLink?.[0]?.secure_url}
          sizes="(max-width: 2464px) 50vw, 1232px"
        >
          {(image) => (
            <FluidImage
              alt={banner.feature.media?.[0]?.altText}
              srcSet={image.srcSet}
              src={image.src}
              sizes={image.sizes}
              className="wix-websites-pdp__take-your-business-further__feature-image"
            />
          )}
        </ProgressiveImage>
      </BannerImage>
    </BannerImageContainer>
  </Banner>
)

export default PartnerCarouselSlide
